const data = [
  {
    id: 1,
    nome: 'Strawberries',
    img: 'https://res.cloudinary.com/thomasdea/image/upload/v1612825605/react-api-course/gelateria/gelato-16_bhll5v.jpg',
    descrizione:
      'Lomo pitchfork gentrify poutine craft beer ugh kale chips. Austin bicycle rights tbh disrupt',
    prezzo: 290,
    categoria: 'cono',
  },
  {
    id: 2,
    nome: 'Yogurt',
    img: 'https://res.cloudinary.com/thomasdea/image/upload/v1612825540/react-api-course/gelateria/gelato-3_nnj0cb.jpg',
    descrizione:
      ' Skateboard dreamcatcher bicycle rights affogato, YOLO edison',
    prezzo: 350,
    categoria: 'coppetta',
  },
  {
    id: 6,
    nome: 'Banana',
    img: 'https://res.cloudinary.com/thomasdea/image/upload/v1612825535/react-api-course/gelateria/gelato-14_ga3apr.jpg',
    descrizione:
      '8-bit hashtag vaporware fixie sartorial normcore meggings pour-over cliche',
    prezzo: 130,
    categoria: 'stick',
  },
];

export default data;
